import * as CATEGORY_ACTION from 'constant/action/category'
import { handleActions } from 'redux-actions'

const initialState = {
  categories: [],
  categoryNavigation: [],
  managementCategories: [],
  pagination: {}
}

export default handleActions(
  {
    [CATEGORY_ACTION.UPDATE_CATEGORIES]: (state, action) => ({
      ...state,
      categories: action.payload
    }),
    [CATEGORY_ACTION.UPDATE_CATEGORY_NAVIGATION]: (state, action) => ({
      ...state,
      categoryNavigation: action.payload
    }),
    [CATEGORY_ACTION.UPDATE_CATAGORY_PAGINATION]: (state, action) => ({
      ...state,
      pagination: action.payload
    }),
    [CATEGORY_ACTION.UPDATE_MANAGEMENT_CATEGORIES]: (state, action) => ({
      ...state,
      managementCategories: action.payload
    })
  },
  initialState
)
